import React, { useContext, useState, useEffect } from 'react';
import { useStripe, CardElement } from '@stripe/react-stripe-js';
import { useNavigate, useLocation } from 'react-router-dom';
import { axios, dataFetcher, endpoints, baseUrl, STRIPE_PUBLIC_KEY } from 'Api';
// eslint-disable-next-line
import html2canvas from "html2canvas";
import { loadStripe } from '@stripe/stripe-js';
import { useDispatch, useSelector } from 'react-redux';
import { clearAllDummys } from 'store/store';
import { AppContext, AuthContext } from 'Context';
import styles from './components/page-layout/index.module.css';
import stripeCredentials from '../../../../../Api/stripeCredentials.json';
import ConfirmCheckoutModal from './ConfirmCheckoutModal';

const Checkout = ({
  planId,
  fromAffilete,
  affiliateInputRef,
  promoInputRef,
  affiliateCode,
  promoCode,
  amount: amountFromApi,
  promoCodeNew,
  checked,
  isPromoError,
  isAffliateError,
  planPrice,
  selectedPlan,
  discountedPrice,
  calculatedDiscount,
  promoName,
}) => {
  const {
    subscriptionDetails,
    userDetails,
    setisFromAffl,
    isFromAffl,
    setAppSnackbar,
    bigUserData,
    expressCheckout,
    isTrail,
    apiCALL,
    expressloading,
    setExpressLoading,
    screatId,
    setScreatId,
    setStripeUiSelector,
    switchingFunction,
    mangerToken,
    userAccessedData,
    managerPaymentMethods,
    trialVal,
  } = useContext(AppContext);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const { getToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const uploadPercentages = useSelector((state) => state.upload);
  const tokens = getToken();
  const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);
  const userData = apiCALL?.data?.userDetails[0] || bigUserData || userAccessedData;
  const userId = userData?.id || userData?.userId || userAccessedData?.userId || userAccessedData?.id || localStorage.getItem('temp_user_id');
  const [capturedImage, setCapturedImage] = useState(null);
  useEffect(() => {
    // console.log('%c[SWITCH-DEBUG] USER-A. Checkout MOUNT', 'color:#ea580c;font-weight:bold', { path: location.pathname, computedUserId: userId, mangerTokenAtMount: !!mangerToken, userAccessedDataAtMount: !!userAccessedData, paymentMode: localStorage.getItem('paymentMode') });
    if (location.pathname === '/pay-by-manger') {
      setisFromAffl(true);
      localStorage.setItem('affliate_userId', userId);
      // console.log('%c[SWITCH-DEBUG] USER-B. wrote affliate_userId', 'color:#ea580c', { affliate_userId: localStorage.getItem('affliate_userId') });
    } else {
      setisFromAffl(false);
      localStorage.removeItem('affliate_userId');
    }
  }, []);

  const captureAndSend = async () => {
    const element = document.getElementById('captureSection');
    if (!element) return console.error('Element not found');

    // Store original display styles
    const affiliateOriginalDisplay = affiliateInputRef.current?.style.display || '';
    const promoOriginalDisplay = promoInputRef.current?.style.display || '';

    // Hide empty input fields before capturing
    if (affiliateInputRef.current && !affiliateInputRef.current.value.trim()) {
      // eslint-disable-next-line
      affiliateInputRef.current.style.display = "none";
    }
    if (promoInputRef.current && !promoInputRef.current.value.trim()) {
      // eslint-disable-next-line
      promoInputRef.current.style.display = "none";
    }

    // Capture the canvas
    const canvas = await html2canvas(element);
    const imageBase64 = canvas.toDataURL('image/png');

    // // Restore the original display styles after capturing
    // if (affiliateInputRef.current) {
    //   // eslint-disable-next-line
    //     affiliateInputRef.current.style.display = affiliateOriginalDisplay;
    // }
    // if (promoInputRef.current) {
    //   // eslint-disable-next-line
    //     promoInputRef.current.style.display = promoOriginalDisplay;
    // }

    return imageBase64;
};

  const clearAllDummy = () => {
    dispatch(clearAllDummys());
  };

  const handleManagerSwitch = async (obj) => {
    // console.log('[SWITCH-DEBUG] 8. handleManagerSwitch entry. paymentMode=', localStorage.getItem('paymentMode'));
    clearAllDummy();
    const result = await switchingFunction(obj);
    // console.log('[SWITCH-DEBUG] 8b. handleManagerSwitch — switchingFunction returned. success=', result?.success, ' paymentMode=', localStorage.getItem('paymentMode'));
    if (result?.success) {
      // console.log('[SWITCH-DEBUG] 8c. handleManagerSwitch — navigating to /dashboard. paymentMode=', localStorage.getItem('paymentMode'));
      navigate('/dashboard');
    }
  };

const handleCheckout = async (imageBase64) => {
  try {
      setExpressLoading(true);

      localStorage.setItem('affiliate', affiliateCode ?? promoCode);
      localStorage.setItem('promocode', promoCodeNew);
      localStorage.setItem('planId', planId);

      const body = new FormData();
      body.append('amount', amountFromApi);

      const stripe = await stripePromise;
      // When manager is accessing a user, use manager's token for purchasing
      const tokenForPurchase = userAccessedData && mangerToken ? mangerToken : getToken();

      const response = await fetch(`${baseUrl}/elements/create-payment-intent`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            token: tokenForPurchase,
            userId,
              promo: localStorage.getItem('promocode'),
              trial: isTrail === '1',
              plan_id: planId,
              for_affiliate: fromAffilete,
              url: window.location.origin,
              image: imageBase64 // Pass Base64 instead of Blob
          })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const { client_secret, amount } = await response.json();
      if (client_secret) {
        setScreatId(client_secret);
    }
      setStripeUiSelector(amount);
    setExpressLoading(false);
  } catch (error) {
    console.error('Checkout failed:', error);
    window.location.href = '/plans';
  }
};

  const handleCaptureAndCheckout = async () => {
    const imageBase64 = await captureAndSend(); // Capture and convert to Base64
    if (imageBase64) {
      await handleCheckout(imageBase64); // Send it
    }
  };
  const checkoutId = subscriptionDetails?.default_payment_methods ?? subscriptionDetails?.paymentMethods[subscriptionDetails?.paymentMethods.length - 1]?.id;

  const isPayByManger = location.pathname === '/pay-by-manger';
  const activePaymentMethods = isPayByManger
    ? managerPaymentMethods
    : subscriptionDetails?.paymentMethods;
  const activeCard = activePaymentMethods?.find(
    (pm) => pm.id === subscriptionDetails?.default_payment_methods
  ) || activePaymentMethods?.[0];
  const cardLast4 = activeCard?.card?.last4;
  const cardBrand = activeCard?.card?.brand;
  const cardExpMonth = activeCard?.card?.exp_month;
  const cardExpYear = activeCard?.card?.exp_year;

  const runSavedCardCheckout = () => {
    // console.log('%c[SWITCH-DEBUG] 7. runSavedCardCheckout ENTRY', 'color:#16a34a;font-weight:bold', { paymentMode: localStorage.getItem('paymentMode'), isPayByManger, mangerTokenAtEntry: !!mangerToken, userAccessedDataAtEntry: !!userAccessedData, mangerTokenVal: mangerToken, localStorageToken: localStorage.getItem('token') });
    if (location.pathname === '/plans') {
      localStorage.setItem('affiliate', affiliateCode ?? promoCode);
    } else {
      localStorage.setItem('affiliate', promoCode);
    }
    localStorage.setItem('promocode', promoCodeNew);
    localStorage.setItem('managerCard', '1');
    const isSwitchModeFlow = localStorage.getItem('paymentMode') === 'switch';
    // Skip handleManagerSwitch when already impersonating. switchingFunction → handleClick
    // would re-run while localStorage.token is the impersonated user's token, capturing
    // the wrong token as "mangerToken" and corrupting the next manager action.
    if (isPayByManger) {
      if (!isSwitchModeFlow && !mangerToken) {
        handleManagerSwitch(apiCALL?.data?.userDetails[0]);
      } else {
        // console.log('%c[SWITCH-DEBUG] 7a. skipping handleManagerSwitch on /pay-by-manger', 'color:#16a34a', { isSwitchModeFlow, alreadyImpersonating: !!mangerToken });
      }
    } else {
      navigate('/access');
    }
    // console.log('%c[SWITCH-DEBUG] 7b. scheduling expressCheckout in 100ms', 'color:#16a34a;font-weight:bold', { mangerToken_NOW: !!mangerToken, userAccessedData_NOW: !!userAccessedData });
    setTimeout(() => {
      const tokenToUse = userAccessedData && mangerToken ? mangerToken : null;
      // console.log('%c[SWITCH-DEBUG] 9. setTimeout FIRED — about to call expressCheckout', 'color:#16a34a;font-weight:bold;font-size:14px', { mangerTokenInClosure: !!mangerToken, userAccessedDataInClosure: !!userAccessedData, tokenToUse_passedToExpressCheckout: tokenToUse, localStorageToken: localStorage.getItem('token') });
      // if (!tokenToUse) {
      //   console.log('%c[SWITCH-DEBUG] 9X. ⚠️ tokenToUse is NULL — expressCheckout will fall back to USER_TOKEN', 'color:#dc2626;font-weight:bold;font-size:14px');
      // }
      expressCheckout(undefined, undefined, undefined, tokenToUse);
    }, 100);
  };

  const expressOrStripe = () => {
    // console.log('[SWITCH-DEBUG] 6. expressOrStripe — Proceed to checkout clicked. checked=', checked, ' paymentMode=', localStorage.getItem('paymentMode'));
    if (checked) {
      setIsConfirmOpen(true);
      return;
    }
    setExpressLoading(true);
    localStorage.setItem('managerCard', '0');
    // handleCaptureAndCheckout();
    handleCheckout();
  };

  const handleConfirmSavedCardCheckout = () => {
    // console.log('[SWITCH-DEBUG] 6b. ConfirmCheckoutModal — Confirm clicked. paymentMode=', localStorage.getItem('paymentMode'));
    setExpressLoading(true);
    setIsConfirmOpen(false);
    runSavedCardCheckout();
  };
  console.log('planId', planId);
  const montserratFont = { fontFamily: "'Montserrat', sans-serif" };
  return (
    <div style={montserratFont}>
      <ConfirmCheckoutModal
        isVisible={isConfirmOpen}
        onCancel={() => setIsConfirmOpen(false)}
        onConfirm={handleConfirmSavedCardCheckout}
        cardLast4={cardLast4}
        cardBrand={cardBrand}
        cardExpMonth={cardExpMonth}
        cardExpYear={cardExpYear}
        promoCode={promoCodeNew}
        loading={expressloading}
        planPrice={planPrice}
        selectedPlan={selectedPlan}
        discountedPrice={discountedPrice}
        calculatedDiscount={calculatedDiscount}
        promoName={promoName}
        isTrail={isTrail}
        trialVal={trialVal}
      />
      {!screatId && (
      <button
        className={styles.continueButton}
        style={montserratFont}
        disabled={expressloading || isPromoError || isAffliateError}
        onClick={expressOrStripe}
      >
        {expressloading === true ? (
          <svg
            className="loading-circle_mini"
            width="20"
            height="20"
            viewBox="0 0 50 50"
          >
            <circle
              className="circle"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              strokeWidth="4"
            />
          </svg>
        ) : (
          'Proceed to checkout'
        )}
      </button>
      )}
    </div>
  );
};

export default Checkout;
